var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckedCategory = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F36805",
  d: "M7.331 15.611a1.52 1.52 0 0 1-1.094-.481l-3.893-4.31 1.225-1.093 3.784 4.21L16.42 4.16l1.203 1.094-9.187 9.844c-.14.15-.31.27-.498.353s-.401.159-.607.161"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedCategory);
export default ForwardRef;